import { getCheckedLayersKeyFromSession } from "./getCheckedLayersSessionKey";

export function getCheckedLayersFromSession(projectId: string): string[] | undefined {
  const key = getCheckedLayersKeyFromSession(projectId);
  return JSON.parse(sessionStorage.getItem(key)) || undefined;
}
